<template>
  <div>
    <header class="page-header -sub-page">
      <section class="page-header__hgroup">
        <h1 v-appear:right="{ delay: [$scroll, 650] }" class="page-header__title">{{ conference.name }}</h1>

        <h2 v-appear:right="{ delay: [$scroll, 700, 50] }" class="layout-section__subtitle -accent">
          {{ $t('common.navigation.gallery') }}
        </h2>
      </section>
    </header>

    <section class="layout-section">
      <template v-for="({ title, images }, galleryIndex) in galleries">
        <article :key="title" class="layout-section__content">
          <section v-appear:right="{ delay: [$scroll, 750, 100] }" class="layout-section__hgroup -flex -spacing">
            <h2 class="layout-section__heading -bigger">{{ title }}</h2>
          </section>

          <section :key="`${title}-images`" class="layout-grid -bigger">
            <div
              v-for="(image, imageIndex) in images"
              :key="image"
              v-appear="{ threshold: 0, offset: 0, delay: getImgDelay(galleryIndex, imageIndex) }"
              class="layout-grid__item"
            >
              <figure class="layout-gallery__item" :style="{ '--image': `url('${image}')` }" />
            </div>
          </section>
        </article>
      </template>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ConferenceGallery',
  props: {
    slug: { type: String, required: true }
  },
  metaInfo() {
    return {
      title: `${this.$t('common.navigation.galleryShort')} | ${this.conference.name}`
    }
  },
  computed: {
    conference() {
      return this.$i18n.messages[this.$i18n.locale].conferences[this.slug]
    },
    galleries() {
      return this.conference.hasGallery === 'true' ? this.conference.gallery : []
    }
  },
  methods: {
    getImgDelay(galleryIndex, imageIndex) {
      const isFirstRow = galleryIndex === 0 && imageIndex < 3
      const delay = (imageIndex * 50) % 150
      return isFirstRow ? [this.$scroll, 800 + delay, delay] : delay
    }
  }
}
</script>
